import React, { useState, useRef } from "react";
import debounce from "lodash/debounce";

import Results from "./Results";
import Icon from "../Icon";

const apiUrl = "/wp-json/salesforce/v1/funds";

const FundQuickSearch = () => {
  const queryEl = useRef(null);
  const [query, setQuery] = useState("");

  const handleSearch = debounce((value, event) => {
    setQuery("");
    setQuery(value);
  }, 300);

  // clear the query and close the quicksearch if the user clicks off of it
  const body = document.querySelector("body");
  body.addEventListener("click", (event) => {
    if (!event.target.closest(".QuickSearch")) {
      setQuery("");
      queryEl.current.value = "";
    }
  });

  return (
    <div className="QuickSearch">
      <form
        className="QuickSearch-form"
        onSubmit={(event) => event.preventDefault()}
      >
        <label htmlFor="QuickSearch-query" className="u-screenreader">
          Search for a disease, medication, or service
        </label>
        <input
          autoComplete="off"
          id="QuickSearch-query"
          className="QuickSearch-query"
          type="text"
          placeholder="Search for a disease, medication, or service"
          ref={queryEl}
          onChange={(event) => handleSearch(event.target.value, event)}
        />
        <button className="QuickSearch-submit" type="submit">
          <span className="u-screenreader">Submit</span>
          Search
        </button>
      </form>

      {query && <Results url={apiUrl} params={{ searchterm: query }} />}
    </div>
  );
};

export default FundQuickSearch;
